import React, { useState } from 'react';
import styles from './ChatBot.module.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMessage, faTimes } from '@fortawesome/free-solid-svg-icons';

const ChatBot = () => {
    const [open, setOpen] = useState(false);

    return (
        <>
            <button
                className={`${styles.chatBotButton} ${open ? styles.open : ''}`}
                onClick={() => setOpen(!open)}
                aria-label={open ? "Close ChatBot" : "Open ChatBot"}
            >
                <FontAwesomeIcon
                    icon={open ? faTimes : faMessage}
                    className={styles.icon}
                />
                <span className={styles.buttonText}>Need Help?</span>
            </button>
            <iframe
                src="https://www.chatbase.co/chatbot-iframe/B7rnXkOnwhHcCR0-1dbkd"
                className={`${styles.chatBotIframe} ${open ? styles.open : ''}`}
                title="ChatBot"
                allow="clipboard-write"
            />
        </>
    );
};

export default ChatBot;
